import { ViewerMode } from 'features/pointClouds'
import { EnvironmentControlsR3f } from 'gecko-3d-tiles-renderer'
import { HotkeyNavigation } from 'pages/pointClouds/components/HotkeyNavigation'
import { PointerLockNavigation } from 'pages/pointClouds/controls/PointerLockNavigation'
import React from 'react'
import { Vector3 } from 'three'

import { PointSelector } from './observations/PointSelector'
import { PointHover } from './tooltips/PointHover'
import { HoveredPointData } from './tooltips/usePointHover'

interface ViewerModeControlsProps {
  viewerMode: ViewerMode
  onHit: (position: Vector3 | null) => void
  onClick: (position: Vector3) => void
  onHover?: (hoverData: HoveredPointData | null) => void
  enableTooltips?: boolean
}

export const ViewerModeControls: React.FC<ViewerModeControlsProps> = ({
  viewerMode,
  onHit,
  onClick,
  onHover,
  enableTooltips = true,
}) => {
  let viewerModeControls = null
  switch (viewerMode) {
    case ViewerMode.POINTER_NAV:
      viewerModeControls = (
        <>
          <PointerLockNavigation />
          {enableTooltips && <PointHover onHover={onHover} enabled={true} />}
        </>
      )
      break
    case ViewerMode.SELECTION:
      viewerModeControls = (
        <PointSelector
          onHit={onHit}
          enabled={viewerMode === ViewerMode.SELECTION}
          onClick={onClick}
        />
      )
      break
    case ViewerMode.ENV_CONTROLS:
      viewerModeControls = (
        <>
          <EnvironmentControlsR3f
            enableDamping={true}
            adjustHeight={false}
            useFallbackPlane={false}
          />
          {enableTooltips && <PointHover onHover={onHover} enabled={true} />}
        </>
      )
      break
    default:
      return null
  }

  return (
    <>
      <HotkeyNavigation />
      {viewerModeControls}
    </>
  )
}
